module.exports = ".password-requirments label {\n  margin-top: 5px; }\n\n.password-requirments ul {\n  font-size: 9px; }\n"